const alerts = {
    'alert.whoops': 'Er is iets mis gegaan',
    'alert.whoops.message.password_mismatch': 'De wachtwoorden komen niet met elkaar overeen!',
    'alert.whoops.message.password_required': 'Het is verplicht een wachtwoord op te geven!',
    'alert.whoops.message.invalid_email': 'Er is geen geldig e-mailadres ingevoerd, probeer het nogmaals',
    'alert.whoops.message.preferred_language.required': 'Taal is een verplicht veld',
    'alert.whoops.message.company.required': 'Bedrijf is een verplicht veld',

    'alert.whoops.message.firstname.required': 'Voornaam is een verplicht veld',
    'alert.whoops.message.lastname.required': 'Achternaam is een verplicht veld',
    'alert.whoops.message.email.required': 'Email is een verplicht veld',
    'alert.whoops.message.email.invalid': 'Email is niet goed ingevuld',
    'alert.whoops.message.subscription.required': 'Je bent verplicht om een abonnement te kiezen',

    'alert.success': 'Yeah!',
    'alert.success.message.saved': 'De wijzigingen zijn met succes opgeslagen.',
    'alert.success.message.registered': 'Registratie is gelukt, je wordt doorgestuurd naar de login pagina',
    'alert.success.message.register_client': 'Registratie is gelukt, Er is een e-mail verstuurd naar je verstuurd om je account te activeren',
    'alert.success.message.subscribed': 'Je hebt je met succes geabonneerd op het gratis plan, veel plezier',
    'alert.success.message.synchronisation_started': 'De synchronisatie is met succes gestart',

    'alert.confirm.delete': 'Weet je zeker dat je dit item wilt verwijderen?',
    'alert.confirm.disable': 'Weet je zeker dat je dit item wilt uitschakelen?',
    'alert.confirm.cancel_upcoming_payment': 'Weet je zeker dat je het komende betaalplan wilt annuleren?',
    'alert.confirm.enable': 'Weet je zeker dat je dit item wilt inschakelen?',
    'alert.confirm.allow': 'Weet je zeker dat je dit wilt toestaan?',
    'alert.confirm.disallow': 'Weet je zeker dat je dit niet wilt toestaan?',
    'alert.confirm.invitation.resend': 'Weet je zeker dat je de uitnodiging opnieuw wilt versturen?',
    'alert.confirm.start_synchronisation': 'Weet je zeker dat je de synchronisatie wilt starten?',
    'alert.confirm.start_dryrun': 'Weet je zeker dat je de dry run synchronisatie wilt starten?',
    'alert.confirm.active_start_synchronisation': 'LET OP De synchronisatie is nog bezig! Weet je zeker dat je de synchronisatie opnieuw wilt starten?',
    'alert.confirm.active_start_dryrun': 'LET OP De synchronisatie is nog bezig! Weet je zeker dat je de dry run synchronisatie opnieuw wilt starten?',
    'alert.confirm.delete.unsaved.changes': 'Weet je zeker dat je dit item wilt verwijderen? Alle niet opgeslagen wijzigingen gaan verloren.',
    'alert.confirm.full_sync': 'Ja, volledig',
    'alert.confirm.only_feed_changes': 'Ja, wijzigingen',

    'alert.title.invitation.send': 'Uitnodiging verstuurd!',
    'alert.title.invitation.resend': 'Uitnodiging opnieuw verstuurd!',

    'alert.combine.brands.magento': 'Magento heeft geen merken. Een merk kan wel aangemaakt worden als attribuut.',
    'alert.combine.brands.woocommerce': 'WooCommerce heeft geen merken. Een merk kan wel aangemaakt worden als attribuut.',
    'alert.combine.customergroups.woocommerce': 'WooCommerce heeft geen klantgroepen, echter kan je hier wel een korting configureren.',
    'alert.combine.languages.woocommerce': 'WooCommerce heeft geen talen.',
    'alert.pricing.not.needed': 'Er hoeven hier geen instellingen gemaakt te worden aangezien verkoopprijs al ingesteld is',

    'alert.title.succes': 'Gelukt!',
    'alert.confirm.client.change': 'Weet je zeker dat je deze klant wilt gaan deactiveren/activeren?',

    'alert.subscriptions.custom_subscription_requested': 'De aanvraag voor een aangepast abonnement is ingediend. Je ontvangt hier ter bevestiging ook een e-mail van.',
    'alert.subscriptions.subscription_scheduled': 'De wijziging van jouw abonnement is met succes ingepland, de wijzigingen gaan in op %scheduled_at%',
    'alert.subscriptions.upcoming_canceled': 'Het aankomende betaalplan is met succes geannuleerd.',
    'alert.subscriptions.has_custom_subscription_options': 'Er is/zijn een of meerdere aangepaste abonnement optie goedgekeurd in jouw account. Deze herken je in het overzicht aan de groene kleur. Kies het gewenste abonnement en klik op "Ga door naar betalen" om de betaling af te ronden.',

    'alert.remove_account.title': 'Account verwijderen?',
    'alert.remove_account.text': 'Wanneer je zeker weet dat je het account wilt verwijderen vragen wij je een mail te sturen naar support@onlineshopconnector.com met daarin je verzoek je account te verwijderen.',
};

export default alerts;
